var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Snackbar as MuiSnackbar } from '@material-ui/core';
import { Grid } from "../Grid/Grid";
import { Sheet } from "../Sheet/Sheet";
import { Typography } from "../Typography/Typography";
var styles = function (theme) { return ({
    root: {},
    center: {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)',
    },
    right: {
        left: 'auto',
        right: theme.spacing(1),
    },
    left: {
        left: theme.spacing(1),
        right: 'auto',
    },
    content: {
        padding: theme.spacing(2),
        borderRadius: 4,
        boxShadow: theme.shadows[2],
        minWidth: 360,
    },
    text: {
        lineHeight: '16px',
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnSnackbar' });
export var Snackbar = function (props) {
    var _a;
    var message = props.message, action = props.action, propClassName = props.className, style = props.style, propClasses = props.classes, anchorOrigin = props.anchorOrigin, others = __rest(props, ["message", "action", "className", "style", "classes", "anchorOrigin"]);
    var classes = useStyles({ classes: propClasses });
    /**
     * Snackbarのスタイルで使われているbreakpointのsmがdefaultThemeで未定義のためスタイルが崩れてしまい
     * Snackbarと同じ高さの領域でClickAwayListenerによるonCloseがうまく発火しない問題を解決するため、
     * 横方向のスタイルのみ上書きする。
     */
    var rootClassName = classNames(classes.root, (_a = {},
        _a[classes.center] = (anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal) === 'center' || anchorOrigin == null,
        _a[classes.left] = (anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal) === 'left',
        _a[classes.right] = (anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal) === 'right',
        _a));
    return (React.createElement(MuiSnackbar, __assign({ className: rootClassName, anchorOrigin: anchorOrigin }, others),
        React.createElement(Sheet, { dark: true, className: classNames(classes.content, propClassName), style: style },
            React.createElement(Typography, { className: classes.text }, message),
            action && (React.createElement(Grid, { container: true, justify: "flex-end" }, action)))));
};
